/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class FileDto {
	public id: number = 0;
	public filename: string = "";
	public mimetype: string = "";
	public filedata: string = "";
	public guid: string = "";
}
